import { ensureAnonymousAuth } from "../auth/anonymousAuth";
import { getAnalyticsRequestMetadata } from "../Analytics";
import { resolveActiveFunctionUrl } from "../../configs/runtimeEnvironment";

function resolveLettuceTalkCardShareUrl(
  functionName,
  explicitDevUrl,
  explicitProdUrl
) {
  return resolveActiveFunctionUrl(functionName, {
    devUrl: explicitDevUrl,
    prodUrl: explicitProdUrl,
    devFallbackUrls: [
      process.env.REACT_APP_SHARE_LETTUCE_TALK_CARD_URL_DEV,
      process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_DEV,
    ],
    prodFallbackUrls: [
      process.env.REACT_APP_SHARE_LETTUCE_TALK_CARD_URL_PROD,
      process.env.REACT_APP_CREATE_LETTUCE_TALK_CARDS_URL_PROD,
    ],
  });
}

async function postAuthenticatedCardShareRequest(url, body, missingUrlMessage) {
  const user = await ensureAnonymousAuth();
  const idToken = await user.getIdToken();

  if (!url) {
    throw new Error(missingUrlMessage);
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ ...body, ...getAnalyticsRequestMetadata() }),
    mode: "cors",
  });
  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || "Failed to share LettuceTalk card");
    error.status = response.status;
    error.details = data.details || "";
    throw error;
  }

  return data;
}

export async function shareLettuceTalkCard({
  cardId,
  channel,
  referredByShareId,
}) {
  const body = { cardId, channel };

  if (referredByShareId) {
    body.referredByShareId = referredByShareId;
  }

  return postAuthenticatedCardShareRequest(
    resolveLettuceTalkCardShareUrl("shareLettuceTalkCard"),
    body,
    "Missing share LettuceTalk card function URL"
  );
}

export async function recordLettuceTalkCardShare({
  cardId,
  shareId,
  channel,
}) {
  return postAuthenticatedCardShareRequest(
    resolveLettuceTalkCardShareUrl(
      "recordLettuceTalkCardShare",
      process.env.REACT_APP_RECORD_LETTUCE_TALK_CARD_SHARE_URL_DEV,
      process.env.REACT_APP_RECORD_LETTUCE_TALK_CARD_SHARE_URL_PROD
    ),
    { cardId, shareId, channel },
    "Missing record LettuceTalk card share function URL"
  );
}
